import React from 'react';
import PropTypes from 'prop-types';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import Popup from '../../../../components/Popup';
import UxHelpers from '../../../../helpers/ux-helpers';
import Dialog from '../../index';

const SendMessageRestrictionDialog = props => {
  const { show, dismiss, limit, upgradeRequestEmail } = props;

  const dismissHandler = () => {
    dismiss();
    UxHelpers.overflowLock('unlock');
  };

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        btnHref={`mailto:${upgradeRequestEmail}`}
        controlFunc={dismissHandler}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText={'Contact us'}
      />
      <BasicButton
        controlFunc={dismissHandler}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText={'No Thanks'}
      />
    </BasicButtonGroup>
  );

  const body = (
    <Dialog>
      <div>
        {`Your current enterprise account provides you with ${limit} direct inbound messages to candidates via Search per month. You have already reached your limit for this month. Contact us if interested in upgrading your enterprise account to receive more monthly inbound messages.`}
      </div>
    </Dialog>
  );

  return (
    show && (
      <Popup
        actions={{
          dismiss,
        }}
        buttonsRender={buttons}
        popupStyles={{
          padding: '30px 25px',
          width: '100%',
          maxWidth: '760px',
        }}
        bodyRender={body}
      />
    )
  );
};

SendMessageRestrictionDialog.propTypes = {
  limit: PropTypes.number.isRequired,
  upgradeRequestEmail: PropTypes.string.isRequired,
};

export default createConfirmation(confirmable(SendMessageRestrictionDialog));
